import { render, staticRenderFns } from "./result_table.vue?vue&type=template&id=0cd8ea90&scoped=true&"
import script from "./result_table.vue?vue&type=script&lang=js&"
export * from "./result_table.vue?vue&type=script&lang=js&"
import style0 from "./result_table.vue?vue&type=style&index=0&id=0cd8ea90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd8ea90",
  null
  
)

export default component.exports